import { t } from 'i18next'
import { DASH } from 'modules/constants'

export const getName = (data) => `${data?.full_name ?? DASH}${data?.is_active ? '' : t('common:deactivated')}`
